import {
    GET_DASHBOARD_USERS,
    BOOKINGS_CANCELLATION_ERROR,
    BOOKINGS_ERROR,
    DRIVERS_BANNED_ERROR,
    DRIVERS_FAQ_ERROR,
    DRIVERS_NEW_ERROR,
    DRIVERS_VALID_ERROR,
    DROPPOINTS_ERROR,
    GET_BOOKINGS,
    GET_BOOKINGS_CANCELLATION,
    GET_DRIVERS_BANNED,
    GET_DRIVERS_FAQ,
    GET_DRIVERS_NEW,
    GET_DRIVERS_VALID,
    GET_DROPPOINTS,
    GET_LINE,
    GET_PAYEMENT,
    GET_TIMESLOT,
    GET_TRIP,
    GET_TRIP_CANCELLATION,
    GET_USERS,
    GET_USERS_FAQ,
    LINE_ERROR,
    PAYEMENT_ERROR,
    TIMESLOT_ERROR,
    TRIP_CANCELLATION_ERROR,
    TRIP_ERROR,
    USERS_ERROR,
    USERS_FAQ_ERROR,
    DASHBOARD_USERS_ERROR,
    GET_DASHBOARD_LOADING,
    COUPON_ERROR,
    PATCH_COUPON,
    POST_LINE,
    LINE_LOADING, SET_SNACKBAR_CONTENT, CLOSE_SNACKBAR
} from '../types'

import * as ActionTypes from '../types';

import axios from "axios"
import {
    endpoint_get_rider ,
    endpoint_get_rider_faq ,
    endpoint_get_driver_approved ,
    endpoint_get_driver_banned,
    endpoint_get_driver_subscribed,
    endpoint_get_booking ,
    endpoint_get_cancellation_booking ,
    endpoint_get_cancellation_trip ,
    endpoint_get_driver_faq,
    endpoint_get_payement,
    endpoint_get_line,
    endpoint_get_droPoints ,
    endpoint_get_timeslot ,
    endpoint_get_trip,
    endpoint_get_dashboard_users,
    endpoint_post_new_user_dashboard,
    endpoint_patch_activate_deactivate_admin_account,
    endpoint_patch_dashboard_user_authorities,
    endpoint_patch_approv_driver,
    endpoint_post_coupon,
    endpoint_patch_coupon,
    endpoint_delete_coupon,
    endpoint_get_stats_landing,
    endpoint_get_driver_trips_confirmed,
    endpoint_get_driver_trips_declined,
    endpoint_get_driver_trips_in_progress,
    endpoint_get_bookings_requests,
    endpoint_get_lines_requests,
    endpoint_patch_booking_request,
    endpoint_post_new_authority_user_dashboard,
    endpoint_get_operational_drivers,
    endpoint_get_sms_gateway,
    endpoint_post_sms_gateway
} from 'config'
import { endpoint_get_coupon } from 'config';

import gender from 'gender-detection';
import {useHistory} from "react-router-dom";
import moment from "moment";
import 'moment/locale/en-gb';


const headers = {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
};

const gotUsers=(users)=>{
    return {
        type : ActionTypes.GET_USERS,
        payload : users

    }
}

const getUsersLoading=()=>{
    return{
        type : ActionTypes.GET_USERS_LOADING
    }
}

const getUsersError=(err)=>{
    return {
        type : ActionTypes.USERS_ERROR,
        payload : err
    }
}
/* Related Riders */
export const getUsers = () => async dispatch => {

    dispatch(getUsersLoading(true));
    axios.get(endpoint_get_rider,
        { headers: headers }
    ).then(res=>{dispatch(gotUsers(res.data.data))})
        .catch(err=>dispatch(getUsersError(err.message)));
};


export const getUsersFAQ = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_rider_faq ,
            headers : headers
        });

        dispatch({
            type: GET_USERS_FAQ,
            payload: res['data'].data
        })
    }

    catch(error) {

        dispatch({
            type: USERS_FAQ_ERROR,
            payload: error,
        })

    }

};

/* Related DriversOperational */

export const getValidDrivers = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_driver_approved ,
            headers : headers
        });


        const validDriversList = res['data'].data.filter((value) => true) ;

        const validDriverListReformated = validDriversList.map((elmt) => {
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                sourceLine : elmt.lines === undefined || elmt.lines.length === 0 ?  '' : elmt.lines[0]?.sourceName ,
                destinationLine : elmt.lines === undefined || elmt.lines.length === 0 ?  '' : elmt.lines[0]?.destinationName ,
                globalRatingDriver : elmt.rating === undefined || elmt.rating === '' ? '' : elmt.rating.globalRating
            }
        });


        //console.log(validDriverListReformated)

        dispatch({
            type: GET_DRIVERS_VALID,
            payload: validDriverListReformated
        })
    }

    catch(error) {

        dispatch({
            type: DRIVERS_VALID_ERROR,
            payload: error,
        })

    }

};


export const getNewDrivers = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_driver_subscribed ,
            headers : headers
        });

        const newDriversList = res['data'].data.filter((value) => true );

        const newDriversListReformated = newDriversList.map((elmt)=> {
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
            }
        });

        dispatch({
            type: GET_DRIVERS_NEW,
            payload: newDriversListReformated
        })
    }

    catch(error) {

        dispatch({
            type: DRIVERS_NEW_ERROR,
            payload: error,
        })

    }

};


export const getBannedDrivers = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_driver_banned ,
            headers : headers
        });

        const bannedDriversList = res['data'].data.filter((value) => true ) ;

        const bannedDriversListReformated = bannedDriversList.map((elmt)=>{
            return {
                ...elmt,
                timestamps : elmt.createdAt.slice(0,10),
            }
        })

        dispatch({
            type: GET_DRIVERS_BANNED,
            payload: bannedDriversListReformated
        })
    }

    catch(error) {

        dispatch({
            type: DRIVERS_BANNED_ERROR,
            payload: error,
        })

    }

};



export const getDriversFAQ = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_driver_faq ,
            headers : headers
        });

        dispatch({
            type: GET_DRIVERS_FAQ,
            payload: res['data'].data
        })
    }

    catch(error) {

        dispatch({
            type: DRIVERS_FAQ_ERROR,
            payload: error,
        })

    }

};

/* Related DropPoints */


export const getDropPoints = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_droPoints ,
            headers : headers
        });

        dispatch({
            type: GET_DROPPOINTS,
            payload: res['data'].data.points
        })
    }

    catch(error) {

        dispatch({
            type: DROPPOINTS_ERROR,
            payload: error,
        })

    }

};

/* Realated bookings */
export const getBookings = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_booking ,
            headers : headers
        });

        const bookingList = res['data'].data.bookings ;

        const bookingListReformated = bookingList.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                departureBookingAdress : elmt.departureAdress["adressName"],
                arrivalBookingAdress : elmt.arrivalAdress["adressName"],
                riderFullName : elmt.id_rider ? elmt.id_rider["fullName"] : 'NULL' ,
                riderPhoneNumber : elmt.id_rider? elmt.id_rider["phoneNumber"] : 'NULL',
                departureDateTrip : elmt.id_trip?elmt.id_trip["departureDate"]:'',
                arrivalDateTrip : elmt.id_trip?elmt.id_trip["arrivalDate"]:'',
                availableSeats : elmt.id_trip?elmt.id_trip["availableSeats"]:'',
                idTrip : elmt.id_trip?elmt.id_trip["_id"]:'',

            }
        })

        dispatch({
            type: GET_BOOKINGS,
            payload: bookingListReformated
        })
    }

    catch(error) {

        dispatch({
            type: BOOKINGS_ERROR,
            payload: error,
        })

    }
};


export const getCancellationBookings = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_cancellation_booking ,
            headers : headers
        });

        //console.log(res['data'].data.cancellationReasons)
        dispatch({
            type: GET_BOOKINGS_CANCELLATION,
            payload: res['data'].data.cancellationReasons
        })

    }

    catch(error) {

        dispatch({
            type: BOOKINGS_CANCELLATION_ERROR,
            payload: error,
        })

    }

};

/* Related Timeslot */

export const getTimeSlot = () => async dispatch => {


    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_timeslot ,
            headers : headers
        });

        const dataobj = res['data'].data.map((elmt) => {
            const TimeSlotHelper = {
                _id : elmt._id ,
                isActive : elmt.isActive ,
                timeSlotStart : ('0'+ elmt.timeSlotStart.hour).slice(-2)  + ":" + ('0'+ elmt.timeSlotStart.minute).slice(-2) ,
                timeSlotEnd : ('0'+ elmt.timeSlotEnd.hour).slice(-2)  + ":" + ('0'+ elmt.timeSlotEnd.minute).slice(-2) ,
                timeSlot : ('0'+ elmt.timeSlotStart.hour).slice(-2)  + ":" + ('0'+ elmt.timeSlotStart.minute).slice(-2) + "-" + ('0'+ elmt.timeSlotEnd.hour).slice(-2)  + ":" + ('0'+ elmt.timeSlotEnd.minute).slice(-2) ,
                isDay : elmt.isDay
            } ;

            return TimeSlotHelper ;
        });

        dispatch({
            type: GET_TIMESLOT,
            payload: dataobj
        })
    }

    catch(error) {

        dispatch({
            type: TIMESLOT_ERROR,
            payload: error,
        })

    }

};

/* Realated Trips */

export const getTrips = () => async dispatch => {
    let momentZone = require('moment-timezone');

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_trip ,
            headers : headers
        });

        const tripList = res['data'].data.trips ;

        const tripListReformated = tripList.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                driverFullName : elmt.id_driver ? elmt.id_driver['fullName'] : 'NULL',
                driverPhoneNumber : elmt.id_driver ? elmt.id_driver['phoneNumber'] : 'NULL',
                arrivalTimeslot : elmt.id_arrival_timeSlot['timeSlot'],
                departureTimeslot : elmt.id_departure_timeSlot['timeSlot'],
                destinationTrip : elmt.direction ? elmt.id_line?.["destinationName"] : elmt?.id_line?.["sourceName"],
                sourceTrip :  elmt.direction ? elmt?.id_line?.["sourceName"] : elmt.id_line?.["destinationName"]  ,
                pricePerSiteTrip : elmt?.id_line?.["pricePerSeat"] ,
                estimatedDurationTrip : elmt?.id_line?.["estimatedDuration"],
                timeSlot : elmt.id_arrival_timeSlot.timeSlot,
                departureDate: momentZone.tz(elmt.departureDate , "Africa/Algiers").format('L')

            }
        });

        dispatch({
            type: GET_TRIP,
            payload: tripListReformated
        })
    }


    catch(error) {

        dispatch({
            type: TRIP_ERROR,
            payload: error,
        })

    }

};


export const getCancellationsTrips = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_cancellation_trip ,
            headers : headers
        });

        dispatch({
            type: GET_TRIP_CANCELLATION,
            payload: res['data'].data.cancellationReasons
        })
    }

    catch(error) {

        dispatch({
            type: TRIP_CANCELLATION_ERROR,
            payload: error,
        })

    }

};

/* Realted Lines */

export const getlines = () => async dispatch => {

    try {
        const res = await axios({
            method : "GET" ,
            url : endpoint_get_line ,
            headers : headers
        });

        dispatch({
            type: GET_LINE,
            payload: res['data'].data
        })
    }

    catch(error) {

        dispatch({
            type: LINE_ERROR,
            payload: error,
        })

    }

};

/* Realted Payement */

export const getPayement = () => async dispatch => {

    try {

        const res = await axios({
            method : "GET" ,
            url : endpoint_get_payement ,
            headers : headers
        });

        const resAllDrivers = await axios({
            method : "GET" ,
            url : endpoint_get_driver_approved ,
            headers : headers
        });

        const payementHistory = res['data'].data ;
        const driversList = (id) =>  resAllDrivers['data'].data.filter((value)=>value._id === id) ;

        const payementHistoryReformated = payementHistory.map((elmt)=>{
            return {
                ...elmt ,
                driverFullName : driversList(elmt.id_driver).length > 0 ? driversList(elmt.id_driver)[0].fullName:'' ,
                driverPhoneNumber : driversList(elmt.id_driver).length > 0 ? driversList(elmt.id_driver)[0].phoneNumber:'' ,

            }
        });

        dispatch({
            type: GET_PAYEMENT,
            payload: payementHistoryReformated
        })
    }

    catch(error) {

        dispatch({
            type: PAYEMENT_ERROR,
            payload: error,
        })

    }

};

/* Related Coupons  */

export const getCoupon = () => async dispatch => {
    moment.locale('en-gb');
    dispatch(couponLoading());
    let momentZone=require('moment-timezone')
    try {
        const res = await axios({
            method: 'GET',
            url: endpoint_get_coupon,
            headers: headers
        });
        const listCoupon = res.data.data.map((elmt)=>{
            return {
                ...elmt ,
                startDate : momentZone.tz(elmt.startDate , "Africa/Algiers").format('L'),
                startHour: momentZone.tz(elmt.startDate , "Africa/Algiers").format('LT'),
                endDate : momentZone.tz(elmt.endDate , "Africa/Algiers").format('L'),
                endHour: momentZone.tz(elmt.endDate , "Africa/Algiers").format('LT'),

            }
        });

        /* const listCouponPrecent =  listCoupon.filter((value) => value.type === "Percentage") ;
        const listCouponFixed =  listCoupon.filter((value) => value.type === "Fixed") ; */
        //console.log(listCoupon)
        dispatch({
            type: ActionTypes.GET_COUPON,
            payload: listCoupon
        })

    } catch (error) {
        dispatch({
            type: COUPON_ERROR,
            payload: error
        })
    }
}

const couponPosted =(newCoupon)=>{
    return {
        type : ActionTypes.POST_COUPON,
        payload : newCoupon
    }
}
const couponPatched=(updatedCoupon , updatedCouponId)=>{
    return {
        type : ActionTypes.PATCH_COUPON,
        payload : {
            updatedCoupon :updatedCoupon,
            updatedCouponId : updatedCouponId
        }
    }
}



const couponDeleted=(deletedCouponId)=>{
    return {
        type : ActionTypes.DELETE_COUPON,
        payload : deletedCouponId
    }
}
const couponLoading=()=>{
    return {
        type : ActionTypes.COUPON_LOADING
    }
}
const couponError=(err)=>{
    return {
        type : COUPON_ERROR,
        error : err
    }
}

export const postCoupon=(couponToPost)=>(dispatch)=>{
    dispatch(couponLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    // let formattedCouponToPost={...couponToPost , }
    console.log('Coupon To post =', couponToPost);
    axios.post(endpoint_post_coupon,couponToPost , options)
        .then(res=>dispatch(couponPosted(res.data.data)))
        .catch(err=>{console.log('ERROR OBJECT = ' , err);dispatch(couponError(err.message))});
}

export const patchCoupon=(couponToPatch , couponToPatchId)=>(dispatch)=>{
    dispatch(couponLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    console.log('URL = ',endpoint_patch_coupon+couponToPatchId )
    axios.patch(endpoint_patch_coupon+couponToPatchId,couponToPatch , options)
        .then(res=>dispatch(couponPatched(res.data.data , couponToPatchId )))
        .catch(err=>{console.log('ERROR OBJECT = ' , err);dispatch(couponError(err.message))});
}

export const deleteCoupon=(couponToDeleteId)=>(dispatch)=>{
    dispatch(couponLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    console.log('DELETE : ', endpoint_delete_coupon+couponToDeleteId);
    axios.delete(endpoint_delete_coupon+couponToDeleteId, options)
        .then(res=>dispatch(couponDeleted(couponToDeleteId)))
        .catch(err=>{dispatch(couponError(err.message))});
}




const dashboardUsersLoading = ()=>{
    return {
        type : GET_DASHBOARD_LOADING,
    }
}

const dashboardUsersError =(error)=> {
    return {
        type: DASHBOARD_USERS_ERROR,
        payload : error
    }
}

const getDashboardUsers =( data)=>{
    return {
        type :GET_DASHBOARD_USERS,
        payload : data
    }
}

// GET ALL THE USERS DASHBOARDS
export const fetchDashboardUsers= (...email)=>(dispatch)=>{
    dispatch(dashboardUsersLoading(true));
    axios.get(endpoint_get_dashboard_users,
        { headers: headers }
    ).then(res=>{dispatch(getDashboardUsers(res.data.data))})
        .catch(err=>dispatch(dashboardUsersError(err.message)));

}


// ADD A  USER

const newUserDashbaord = (newUser)=>{
    return {
        type : ActionTypes.DASHBOARD_ADD_USERS,
        payload : newUser
    }
}
const newUserDashboardError=(error)=>{
    return {
        type : ActionTypes.DASHBOARD_ADD_USERS_ERROR,
        payload : error
    }
}

export const postNewUserDashboard =(newUser)=>(dispatch)=>{
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    console.log("NEW USER =" , newUser);
    dispatch(dashboardUsersLoading())
    axios.post(endpoint_post_new_user_dashboard ,newUser , options)
        .then(res=>dispatch(newUserDashbaord(res.data.data)))
        .catch(err=>dispatch(newUserDashboardError(err.message)));
}

export const postNewAuthorityUserDashboard =(newAuthority)=>(dispatch)=>{
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    // console.log("NEW USER =" , newUser);
    dispatch(dashboardUsersLoading())
    // console.log('ENDPOINT =',endpoint_post_new_authority_user_dashboard )
    axios.patch(endpoint_post_new_authority_user_dashboard,newAuthority , options)
        .then(res=>dispatch(newAuthorityUserDashboardAdded()))
        .catch(err=>dispatch(newUserDashboardError(err.message)));
}

const newAuthorityUserDashboardAdded=()=>{
    return {
        type : ActionTypes.DASHBOARD_ADD_NEW_AUTHORITY_USER_DASHBAORD
    }
}
// ACTIVATE/DEACTIVATE A USER
const userActivated=(userActivated)=>{
    return {
        type : ActionTypes.DASHBOARD_ACTIVATE_USER ,
        payload : userActivated
    }
}

const userDeactivated=(userDeactivated)=>{
    return {
        type : ActionTypes.DASHBOARD_DEACTIVATE_USER,
        payload : userDeactivated
    }
}

const activateDeactivateUserError=(err)=>{
    return {
        type : ActionTypes.DASHBOARD_DEACTIVATE_ACTIVATE_USER_ERROR,
        payload : err
    }
}

export const activateDeactivateUser=(user)=>(dispatch)=>{
    dispatch(dashboardUsersLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    axios.patch(endpoint_patch_activate_deactivate_admin_account , user , options)
        .then(res=>user.isActivated ? dispatch(userActivated(user)) : dispatch(userDeactivated(user)))
        .catch(err=>dispatch(activateDeactivateUserError(err.message)))
}

const updatedAuthoritiesDashboardUser=(authorities)=>{
    return {
        type : ActionTypes.DASHBOARD_UPDATE_USER_AUTHORITIES,
        payload : authorities
    }
}

const updatedAuthoritiesErrorDashboardUser=(err)=>{
    return {
        type : ActionTypes.DASHBOARD_UPDATE_USER_AUTHORITIES_ERROR,
        payload : err
    }
}

export const updateAuthoritiesDashboardUser =(authorities, loggedOut , history )=>(dispatch , getState)=>{
    dispatch(dashboardUsersLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    axios.patch(endpoint_patch_dashboard_user_authorities , authorities , options)
        .then(res=>{
            dispatch(updatedAuthoritiesDashboardUser(res.data.data))
            if(loggedOut){
                localStorage.clear()
                // setToken()
                // setAnchorEl(null)
                history.push("/login")
            }
        })
        .catch(err=>dispatch(updatedAuthoritiesErrorDashboardUser(err.message)))
}


export const setUserAuthorities=(user)=>{
    return {
        type : ActionTypes.LOGIN_DASHBOARD_USER,
        payload : user
    }
}
export const loginUser=(...email)=>(dispatch , getState)=>{
    if(email.length){
        console.log('EMAIL =' , email)
        let theUserIndex =  getState().dashboardUsers.data.findIndex(user => user.email ===email[0]);
        console.log('index =' , theUserIndex);
        let userAuth=getState().dashboardUsers.data[theUserIndex]
        console.log(' zozo =' , userAuth);
        dispatch(setUserAuthorities(userAuth));
        localStorage.setItem('authorities' , JSON.stringify(userAuth) );
        // window.location.reload(false);
    }else{
        dispatch(setUserAuthorities(JSON.parse(localStorage.getItem('authorities'))));
        // window.location.reload(false);
    }

    // console.log('USER AUTH FROM STORAGE =' ,JSON.parse(localStorage.getItem('authorities')));
}

const  driverApprovedLoading =()=>{
    return {
        type : ActionTypes.APPROVE_DRIVER_LOADING
    }
}
const  driverApprovedError =(err)=>{
    return {
        type : ActionTypes.APPROVE_DRIVER_ERROR,
        payload : err
    }
}

const driverApproved =(id)=>{
    return {
        type : ActionTypes.APPROVE_DRIVER ,
        payload : id
    }
}

export const  approveDriver =(driverApprov , id)=>(dispatch)=>{
    dispatch(driverApprovedLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    axios.patch(endpoint_patch_approv_driver+'/'+id , driverApprov , options)
        .then(res=>{console.log('DATA =', res.data.data);dispatch(driverApproved(res.data.data)); window.location.reload(false);})
        .catch(err=>{ dispatch(driverApprovedError(err.message))})

}

const getStatsLandingLoading=()=>{
    return {
        type : ActionTypes.GET_STATS_LANDING_LOADING
    }
}

const getStatsLandingError=(err)=>{
    return {
        type : ActionTypes.GET_STATS_LANDING_ERROR,
        payload : err
    }
}

const getStatsLanding=(stats)=>{
    return {
        type : ActionTypes.GET_STATS_LANDING,
        payload : stats
    }
}

export const fetchStatsLanding=()=>(dispatch)=>{
    dispatch(getStatsLandingLoading());
    axios.get(endpoint_get_stats_landing, { headers: headers })
        .then(res=>{dispatch(getStatsLanding(res.data.data))})
        .catch(err=>dispatch(getStatsLandingError(err.message)));
}


const linesLoading=()=>{
    return {
        type : LINE_LOADING
    }
}
const lineAdded=(addedLine)=>{
    return {
        type : ActionTypes.POST_LINE,
        payload : addedLine
    }
}

export const postLine=(data , epAddLines)=>(dispatch)=>{
    dispatch(linesLoading())
    const newData = {
        source: Number(data.source),
        destination: Number(data.destination),
        pricePerSeat: data?.pricePerSeat,
        estimatedDuration: data?.estimatedDuration,
        priceState : data.priceState
    }
    console.log(' POSTING REALLY : ', newData)
    // const config = {
    //     method : 'post' ,
    //     url : epAddLines ,
    //     headers : headers ,
    //     data : newData
    // } ;
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    // axios(config)
    axios.post(epAddLines,newData , options)
        .then((res) => {
            console.log("POSTING DATA SUCCESS OK !" , res) ;
            dispatch(lineAdded(res.data.data));

        })
        .catch((err) => {
            console.log("error posting data !! : " , err) ;
        });
}

//DRIVER HISTORY

const getdriverTripsCompleted=(trips)=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_COMPLETED,
        payload : trips
    }
}

const getdriverTripsInProgress=(trips)=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_IN_PROGRESS,
        payload : trips
    }
}

const getdriverTripsDeclined=(trips)=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_DECLINED,
        payload : trips
    }
}

const getdriverTripsCompletedError=(err)=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_COMPLETED_ERROR,
        payload : err
    }
}

const getdriverTripsInProgressError=(err)=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_IN_PROGRESS_ERROR,
        payload : err
    }
}

const getdriverTripsDeclinedError=(err)=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_DECLINED_ERROR,
        payload : err
    }
}

const getdriverTripsCompletedLoading=()=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_COMPLETED_LOADING,
    }
}

const getdriverTripsInProgressLoading=()=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_IN_PROGRESS_LOADING,
    }
}

const getdriverTripsDeclinedLoading=()=>{
    return {
        type : ActionTypes.GET_DRIVER_TRIPS_DECLINED_LOADING,
    }
}

export const fetchGetdriverTripsCompleted=(idDriver)=>(dispatch)=>{
    console.log('id Driver =' , idDriver);
    dispatch(getdriverTripsCompletedLoading())
    console.log(' GET TO ', endpoint_get_driver_trips_confirmed+idDriver+'/finished');
    axios.get(endpoint_get_driver_trips_confirmed+idDriver+'/finished',
        { headers: headers }
    ).then(res=>{
        const tripListReformated = res.data.data.trips.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                driverFullName : elmt.id_driver ? elmt.id_driver['fullName'] : 'NULL',
                driverPhoneNumber : elmt.id_driver ? elmt.id_driver['phoneNumber'] : 'NULL',
                arrivalTimeslot : elmt.id_arrival_timeSlot['timeSlot'],
                departureTimeslot : elmt.id_departure_timeSlot['timeSlot'],
                destinationTrip : elmt.direction ? elmt.id_line?.["destinationName"] : elmt?.id_line["sourceName"],
                sourceTrip :  elmt.direction ? elmt?.id_line?.["sourceName"] : elmt.id_line?.["destinationName"]  ,
                pricePerSiteTrip : elmt?.id_line?.["pricePerSeat"] ,
                estimatedDurationTrip : elmt?.id_line?.["estimatedDuration"],
                timeSlot : elmt.id_arrival_timeSlot.timeSlot

            }
        });
        dispatch(getdriverTripsCompleted(tripListReformated )); console.log(' RES DATA =', res.data)


    })
        .catch(err=>dispatch(getdriverTripsCompletedError(err.message)));
}

export const fetchGetdriverTripsInProgress=(idDriver)=>(dispatch)=>{
    console.log('id Driver =' , idDriver);
    dispatch(getdriverTripsInProgressLoading())
    console.log(' GET TO ', endpoint_get_driver_trips_in_progress+idDriver+'/in-progress');
    axios.get(endpoint_get_driver_trips_in_progress+idDriver+'/in-progress',
        { headers: headers }
    ).then(res=>{
        const tripListReformated = res.data.data.trips.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                driverFullName : elmt.id_driver ? elmt.id_driver['fullName'] : 'NULL',
                driverPhoneNumber : elmt.id_driver ? elmt.id_driver['phoneNumber'] : 'NULL',
                arrivalTimeslot : elmt.id_arrival_timeSlot['timeSlot'],
                departureTimeslot : elmt.id_departure_timeSlot['timeSlot'],
                destinationTrip : elmt.direction ? elmt.id_line?.["destinationName"] : elmt?.id_line?.["sourceName"],
                sourceTrip :  elmt.direction ? elmt?.id_line?.["sourceName"] : elmt.id_line?.["destinationName"]  ,
                pricePerSiteTrip : elmt?.id_line?.["pricePerSeat"] ,
                estimatedDurationTrip : elmt?.id_line?.["estimatedDuration"],
                timeSlot : elmt.id_arrival_timeSlot.timeSlot
            }
        });
        dispatch(getdriverTripsInProgress(tripListReformated )); console.log(' RES DATA =', res.data)


    })
        .catch(err=>dispatch(getdriverTripsInProgressError(err.message)));
}


export const fetchGetdriverTripsDeclined=(idDriver)=>(dispatch)=>{
    console.log('id Driver =' , idDriver);
    dispatch(getdriverTripsDeclinedLoading())
    console.log(' GET TO ', endpoint_get_driver_trips_declined+idDriver+'/cancelled');
    axios.get(endpoint_get_driver_trips_declined+idDriver+'/cancelled',
        { headers: headers }
    ).then(res=>{
        const tripListReformated = res.data.data.trips.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                driverFullName : elmt.id_driver ? elmt.id_driver['fullName'] : 'NULL',
                driverPhoneNumber : elmt.id_driver ? elmt.id_driver['phoneNumber'] : 'NULL',
                arrivalTimeslot : elmt.id_arrival_timeSlot['timeSlot'],
                departureTimeslot : elmt.id_departure_timeSlot['timeSlot'],
                destinationTrip : elmt.direction ? elmt.id_line?.["destinationName"] : elmt?.id_line?.["sourceName"],
                sourceTrip :  elmt.direction ? elmt?.id_line?.["sourceName"] : elmt.id_line?.["destinationName"]  ,
                pricePerSiteTrip : elmt?.id_line?.["pricePerSeat"] ,
                estimatedDurationTrip : elmt?.id_line?.["estimatedDuration"],
                timeSlot : elmt.id_arrival_timeSlot.timeSlot
            }
        });
        dispatch(getdriverTripsDeclined(tripListReformated )); console.log(' RES DATA =', res.data)


    })
        .catch(err=>dispatch(getdriverTripsDeclinedError(err.message)));
}




const bookingsRequestsWaitingLoading=()=>{
    return {
        type : ActionTypes.BOOKINGS_REQUESTS_WAITING_LOADING,
    }
}

const getBookingsRequestsWaiting=(bookingsReq)=>{
    return {
        type : ActionTypes.GET_BOOKINGS_REQUESTS_WAITING ,
        payload : bookingsReq
    }
}

const getBookingsRequestsWaitingError=(err)=>{
    return {
        type : ActionTypes.GET_BOOKINGS_REQUESTS_WAITING_ERROR,
        payload : err
    }
}

export const fetchGetBookingsRequestsWaiting= ()=>(dispatch)=>{
    let momentZone=require('moment-timezone')
    moment.locale('en-gb');
    dispatch(bookingsRequestsWaitingLoading());
    axios.get(endpoint_get_bookings_requests+'/in-progress',
        { headers: headers }
    ).then(res=>{
        const bookingListReformated = res.data.data.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                departureBookingAdress : elmt.departureAdress["adressName"],
                arrivalBookingAdress : elmt.arrivalAdress["adressName"],
                riderFullName : elmt.id_rider ? elmt.id_rider["fullName"] : 'NULL' ,
                riderPhoneNumber : elmt.id_rider? elmt.id_rider["phoneNumber"] : 'NULL',
                departureDateTrip : elmt.id_trip?elmt.id_trip["departureDate"]:'',
                arrivalDateTrip : elmt.id_trip?elmt.id_trip["arrivalDate"]:'',
                availableSeats : elmt.id_trip?elmt.id_trip["availableSeats"]:'',
                idTrip : elmt.id_trip?elmt.id_trip["_id"]:'',
                timeSlot : elmt.id_departure_timeSlot.timeSlot,
                requestDate : momentZone.tz(elmt.createdAt , "Africa/Algiers").format('L'),
                requestHour: momentZone.tz(elmt.createdAt , "Africa/Algiers").format('LT'),
                destinationWilaya : elmt.id_line ? (elmt.direction ? elmt.id_line["destinationName"] : elmt.id_line["sourceName"]) : null,
                sourceWilaya : elmt.id_line ? ( elmt.direction ? elmt.id_line["sourceName"] : elmt.id_line["destinationName"])  : null

            }
        })
        dispatch(getBookingsRequestsWaiting(bookingListReformated))
    })
        .catch(err=>dispatch(getBookingsRequestsWaitingError(err.message)));

}

const bookingsRequestsConfirmedLoading=()=>{
    return {
        type : ActionTypes.BOOKINGS_REQUESTS_CONFIRMED_LOADING,
    }
}

const getBookingsRequestsConfirmed=(bookingsReq)=>{
    return {
        type : ActionTypes.GET_BOOKINGS_REQUESTS_CONFIRMED ,
        payload : bookingsReq
    }
}

const getBookingsRequestsConfirmedError=(err)=>{
    return {
        type : ActionTypes.GET_BOOKINGS_REQUESTS_CONFIRMED_ERROR,
        payload : err
    }
}

export const fetchGetBookingsRequestsConfirmed= ()=>(dispatch)=>{
    let momentZone=require('moment-timezone')
    dispatch(bookingsRequestsConfirmedLoading());
    axios.get(endpoint_get_bookings_requests+'/confirmed',
        { headers: headers }
    ).then(res=>{
        const bookingListReformated = res.data.data.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                departureBookingAdress : elmt.departureAdress["adressName"],
                arrivalBookingAdress : elmt.arrivalAdress["adressName"],
                riderFullName : elmt.id_rider ? elmt.id_rider["fullName"] : 'NULL' ,
                riderPhoneNumber : elmt.id_rider? elmt.id_rider["phoneNumber"] : 'NULL',
                departureDateTrip : elmt.id_trip?elmt.id_trip["departureDate"]:'',
                arrivalDateTrip : elmt.id_trip?elmt.id_trip["arrivalDate"]:'',
                availableSeats : elmt.id_trip?elmt.id_trip["availableSeats"]:'',
                idTrip : elmt.id_trip?elmt.id_trip["_id"]:'',
                timeSlot : elmt.id_departure_timeSlot.timeSlot,
                requestDate : momentZone.tz(elmt.createdAt , "Africa/Algiers").format('L'),
                requestHour: momentZone.tz(elmt.createdAt , "Africa/Algiers").format('LT'),
                destinationWilaya : elmt.id_line ? (elmt.direction ? elmt.id_line["destinationName"] : elmt.id_line["sourceName"]) : null,
                sourceWilaya : elmt.id_line ? ( elmt.direction ? elmt.id_line["sourceName"] : elmt.id_line["destinationName"])  : null


            }
        })
        dispatch(getBookingsRequestsConfirmed(bookingListReformated))
    })
        .catch(err=>dispatch(getBookingsRequestsConfirmedError(err.message)));

}

const bookingsRequestsCancelledLoading=()=>{
    return {
        type : ActionTypes.BOOKINGS_REQUESTS_CANCELLED_LOADING,
    }
}

const getBookingsRequestsCancelled=(bookingsReq)=>{
    return {
        type : ActionTypes.GET_BOOKINGS_REQUESTS_CANCELLED ,
        payload : bookingsReq
    }
}

const getBookingsRequestsCancelledError=(err)=>{
    return {
        type : ActionTypes.GET_BOOKINGS_REQUESTS_CANCELLED_ERROR,
        payload : err
    }
}

export const fetchGetBookingsRequestsCancelled=()=>(dispatch)=>{
    let momentZone=require('moment-timezone');
    dispatch(bookingsRequestsCancelledLoading());
    axios.get(endpoint_get_bookings_requests+'/cancelled',
        { headers: headers }
    ).then(res=>{
        const bookingListReformated = res.data.data.map((elmt)=>{
            return {
                ...elmt ,
                timestamps : elmt.createdAt.slice(0,10),
                departureBookingAdress : elmt.departureAdress["adressName"],
                arrivalBookingAdress : elmt.arrivalAdress["adressName"],
                riderFullName : elmt.id_rider ? elmt.id_rider["fullName"] : 'NULL' ,
                riderPhoneNumber : elmt.id_rider? elmt.id_rider["phoneNumber"] : 'NULL',
                departureDateTrip : elmt.id_trip?elmt.id_trip["departureDate"]:'',
                arrivalDateTrip : elmt.id_trip?elmt.id_trip["arrivalDate"]:'',
                availableSeats : elmt.id_trip?elmt.id_trip["availableSeats"]:'',
                idTrip : elmt.id_trip?elmt.id_trip["_id"]:'',
                timeSlot : elmt.id_departure_timeSlot.timeSlot,
                requestDate : momentZone.tz(elmt.createdAt , "Africa/Algiers").format('L'),
                requestHour: momentZone.tz(elmt.createdAt , "Africa/Algiers").format('LT'),
                destinationWilaya : elmt.id_line ? (elmt.direction ? elmt.id_line["destinationName"] : elmt.id_line["sourceName"]) : null,
                sourceWilaya : elmt.id_line ? ( elmt.direction ? elmt.id_line["sourceName"] : elmt.id_line["destinationName"])  : null,
                destinationWilaya : elmt.direction ? elmt.id_line?.["destinationName"] : elmt?.id_line?.["sourceName"],
                sourceWilaya :  elmt.direction ? elmt?.id_line?.["sourceName"] : elmt.id_line?.["destinationName"]  ,


            }
        })
        dispatch(getBookingsRequestsCancelled(bookingListReformated))
    })
        .catch(err=>dispatch(getBookingsRequestsCancelledError(err.message)));

}

const linesRequestsLoading=()=>{
    return{
        type : ActionTypes.LINES_REQUESTS_LOADING
    }
}

const getLinesRequestsError=(err)=>{
    return {
        type : ActionTypes.GET_LINES_REQUESTS_ERROR,
        payload : err
    }
}

const getLinesRequests=(linesReq)=>{
    return{
        type : ActionTypes.GET_LINES_REQUESTS,
        payload: linesReq
    }
}

export const fetchGetLinesRequests=()=>(dispatch)=>{
    dispatch(linesRequestsLoading());
    axios.get(endpoint_get_lines_requests,
        { headers: headers }
    ).then(res=>{dispatch(getLinesRequests(res.data.data))})
        .catch(err=>dispatch(getLinesRequestsError(err.message)));
}

const bookingRequestConfirmed=(bookingReqConfirmed , bookingSec)=>{
    return {
        type : ActionTypes.PATCH_CONFIRM_BOOKING_REQUEST,
        payload : {
            data :bookingReqConfirmed,
            bookingSection : bookingSec
        }
    }
}
const bookingRequestCancelled=(bookingReqCancelled , bookingSec)=>{
    return {
        type : ActionTypes.PATCH_CANCEL_BOOKING_REQUEST,
        payload : {
            data :bookingReqCancelled,
            bookingSection : bookingSec
        }
    }
}

export const fetchPatchBookingsRequestsConfirm=(bookingReqToConfirmId , bookingsRequestSection)=>(dispatch)=>{
    switch (bookingsRequestSection){
        case 'Waiting':
            dispatch(bookingsRequestsWaitingLoading());
            break;
        case 'Confirmed':
            dispatch(bookingsRequestsConfirmedLoading());
            break;
        case 'Cancelled':
            dispatch(bookingsRequestsCancelledLoading());
            break;
        default:
            dispatch(bookingsRequestsWaitingLoading());
            break;
    }
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}
    };
    console.log('HEADER =' , headers);
    console.log('URL = ',endpoint_patch_booking_request+bookingReqToConfirmId+'/confirmed' )
    axios.patch(endpoint_patch_booking_request+bookingReqToConfirmId+'/confirmed',{}, options)
        .then(res=>dispatch(bookingRequestConfirmed(res.data.data , bookingsRequestSection)))
        .catch(err=>{
            switch (bookingsRequestSection){
                case 'Waiting':
                    dispatch(getBookingsRequestsWaitingError(err.message));
                    break;
                case 'Confirmed':
                    dispatch(getBookingsRequestsConfirmedError(err.message));
                    break;
                case 'Cancelled':
                    dispatch(getBookingsRequestsCancelledError(err.message));
                    break;
                default:
                    dispatch(getBookingsRequestsWaitingError(err.message));
                    break;
            }
        });
}

export const fetchPatchBookingsRequestsCancel=(bookingReqToCancelId , bookingsRequestSection)=>(dispatch)=>{
    switch (bookingsRequestSection){
        case 'Waiting':
            dispatch(bookingsRequestsWaitingLoading());
            break;
        case 'Confirmed':
            dispatch(bookingsRequestsConfirmedLoading());
            break;
        case 'Cancelled':
            dispatch(bookingsRequestsCancelledLoading());
            break;
        default:
            dispatch(bookingsRequestsWaitingLoading());
            break;
    }

    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}
    };
    console.log('HEADER =' , headers);
    console.log('URL = ',endpoint_patch_booking_request+bookingReqToCancelId+'/cancelled' )
    axios.patch(endpoint_patch_booking_request+bookingReqToCancelId+'/cancelled',{}, options)
        .then(res=>dispatch(bookingRequestCancelled(res.data.data, bookingsRequestSection)))
        .catch(err=>{
            switch (bookingsRequestSection){
                case 'Waiting':
                    dispatch(getBookingsRequestsWaitingError(err.message));
                    break;
                case 'Confirmed':
                    dispatch(getBookingsRequestsConfirmedError(err.message));
                    break;
                case 'Cancelled':
                    dispatch(getBookingsRequestsCancelledError(err.message));
                    break;
                default:
                    dispatch(getBookingsRequestsWaitingError(err.message));
                    break;
            }
        });
}

export const copyAndsetSnackBarContent=(text)=>{
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    return {
        type : ActionTypes.SET_SNACKBAR_CONTENT,
        payload : text
    }
}

export const closeSnackBar=()=>{
    return {
        type : CLOSE_SNACKBAR
    }
}

const operationalDriversLoading=()=>{
    return {
        type : ActionTypes.OPERATIONAL_DRIVERS_LOADING
    }
}
const gotOperationalDrivers=(operationalDrivers)=>{
    return {
        type : ActionTypes.GET_OPERATIONAL_DRIVERS,
        payload : operationalDrivers
    }
}
const operationalDriversError=(err)=>{
    return{
        type : ActionTypes.OPERATIONAL_DRIVERS_ERROR,
        payload : err
    }
}

const postOperationalDrivers=(newDriverOperational)=>{
    return{
        type : ActionTypes.POST_OPERATIONAL_DRIVERS,
        payload : newDriverOperational
    }
}
export const fetchGetOperationalDrivers=()=>(dispatch)=>{
    dispatch(operationalDriversLoading());
    axios.get(endpoint_get_operational_drivers,
        { headers: headers }
    ).then(res=>{dispatch(gotOperationalDrivers(res.data.data))})
        .catch(err=>dispatch(operationalDriversError(err.message)));
}

const smsGatewayLoading=()=>{
    return {
        type : ActionTypes.SMS_GATEWAY_LOADING
    }
}
const gotSmsGateway=(smsGateWay)=>{
    return {
        type : ActionTypes.GET_SMS_GATEWAY,
        payload : smsGateWay
    }
}
const smsGatewayError=(err)=>{
    return{
        type : ActionTypes.SMS_GATEWAY_ERROR,
        payload : err
    }
}

const postSmsGateway=(newSms)=>{
    return {
        type : ActionTypes.POST_SMS_GATEWAY,
        payload : newSms
    }
}


export const fetchGetSmsGateway=()=>(dispatch)=>{
    dispatch(smsGatewayLoading());
    axios.get(endpoint_get_sms_gateway,
        { headers: headers }
    ).then(res=>{dispatch(gotSmsGateway(res.data.data))})
        .catch(err=>dispatch(smsGatewayError(err.message)));
}

export const fetchPostSmsGateway=(smsToPost)=>(dispatch)=>{
    dispatch(smsGatewayLoading());
    const options = {
        headers: {...headers, 'Content-Type': 'application/json'}

    };
    // let formattedCouponToPost={...couponToPost , }
    axios.post(endpoint_post_sms_gateway,smsToPost , options)
        .then(res=>dispatch(postSmsGateway(res.data.data)))
        .catch(err=>{dispatch(smsGatewayError(err.message))});;
}